<template>
  <div class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
</template>

<script>
export default {
  name: "ShareRedirect",
  created() {
    this.handleRedirect();
  },
  methods: {
    handleRedirect() {
      const code = this.$route.params.code;

      const apiBase = window.baseURL.replace(/\/v\d+$/, "");
      const url = apiBase + "/get-share-link-full";

      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest",
      };

      this.$axios({
        url: url,
        method: "GET",
        params: {
          code: code
        },
      })
        .then((res) => {
          const link = res.data.data ? res.data.data.link : null;
          if (link) {
            window.location.href = link;
          } else {
            console.log("no link")
            this.$router.push({ name: "404" });
          }
        })
        .catch(() => {
          console.log("error")
          this.$router.push({ name: "404" });
        });
    },
  },
};
</script>
